import { useState } from "react";
import { SubscribeModal } from "./SubscribeModal";
import { MailchimpSubscribeForm } from "./MailchimpSubscribeForm";
import { useLanguage } from '../switchLang/useLang';
import giftBoxIcon from '../../media/giftBox.png';
function SubscribeWidget() {
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();
    const actionUrl =
        "https://siliconeheart.us19.list-manage.com/subscribe/post?u=3f983a4578d90ff9f72e89980&id=81f0234756&f_id=00f0c2e1f0";

    return (
        <>
            <div className="subscribeWrapper">

                {/* Картинка теперь снаружи кнопки */}
                <img
                    src={giftBoxIcon}
                    alt="Gift"
                    className="floatingGiftIcon"
                    onClick={() => setOpen(true)} // Чтобы клик по подарку тоже открывал
                />

                <button className="subscribeBtn" onClick={() => setOpen(true)}>
                    {t("subscribeButton")}
                </button>

                {/* <SubscribeModal open={open} onClose={() => setOpen(false)} /> */}
            </div>

            <SubscribeModal
                open={open}
                title={t("subscribeModalTitle")}
                onClose={() => setOpen(false)}
            >
                <MailchimpSubscribeForm
                    actionUrl={actionUrl}
                    defaultLang="ru"
                    onSuccess={() => {
                        // хочешь — закрывай сразу после успеха
                        // setTimeout(() => setOpen(false), 800);
                    }}
                />
            </SubscribeModal>
        </>
    );
}
export default SubscribeWidget;